import React, { useEffect, useState } from 'react';
import './solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/servicesOverlay.mp4",
    poster: "/videos/servicesOverlay.jpg",
    heading: "One Partner. Total Project Confidence.",
    subheading: "Accelerate data center network builds with turnkey services from design to go-live.​",
    buttonLink: "/support"
  }
];

const facts = [
    { label: "Staff execution", value: 36, prefix: "", suffix: "%", key: "years" },
    { label: "Insufficient staff", value: 28, prefix: "", suffix: "%", key: "continents" },
    { label: "Incorrect procedures", value: 21, prefix: "", suffix: "%", key: "employees" },
  ];

  const data = [
  {
    title: "Our capabilities",
    items: [
      { q: "Do you provide services for all kinds of networks?", a: "Yes. We support the full spectrum of low-voltage and fiber networks, ranging from campus-scale OSP backbones to high-density ISP deployments and in-rack fiber for AI data centers. Our teams work across single-mode and multimode fiber, structured cabling, backbone, spine-leaf, and point-to-point architectures, supporting both greenfield builds and live-environment expansions." },
      { q: "What certifications and credentials do your teams hold?", a: "Our technicians and supervisors hold industry-recognized certifications in fiber installation, fusion splicing, testing, safety, and structured cabling. This includes manufacturer-specific and standards-based training for OSP and ISP environments, ensuring every installation meets or exceeds industry requirements." },
      { q: "What industry experience do you bring?", a: "We bring deep experience delivering fiber infrastructure for large-scale, high-density data center campuses, including AI-driven environments where precision, speed, and quality are non-negotiable." },
      { q: "Do you have experience with hybrid and multi-cloud networking?", a: "Yes. While we do not operate cloud platforms directly, we routinely build the physical fiber infrastructure that enables hybrid and multi-cloud networking environments." },
      { q: "What training do you provide your staff?", a: "Our teams receive ongoing training in fiber handling, splicing, testing, pathway management, labeling standards, and data center best practices. We also emphasize safety, change management, and communication, while staying current with advancements in fiber types, connector standards, higher-fiber-count cables, AI-driven data center architectures, and evolving industry standards." },
      { q: "Are your engineers full-time employees or contractors?", a: "Our core technical leadership and field supervision are full-time professionals. We supplement with trusted, long-term partners as needed to scale, all operating under our standards, processes, and quality controls." },
      { q: "Do you have references?", a: "Yes. We can provide references from data center operators, AI infrastructure providers, and enterprise customers upon request." },
    ],
  },
  {
    title: "Our approach",
    items: [
      { q: "What is your approach to network design and implementation?", a: "We take a disciplined, execution-first approach that aligns design intent with real-world constructability. From planning to sign-off, we collaborate with network and facility owners, engineers, and OEMs to validate routing, pathways, splice architecture, fiber management, power, and physical plant readiness up front, then execute with precision and transparency to minimize surprises in the field." },
      { q: "How do you successfully approach and implement high-scale, fiber-dense AI data center infrastructure?", a: "We take a holistic approach to guarantee robust and scalable connectivity by integrating fiber products with expert services. This includes project management, customized pathway design, precise cable configuration, comprehensive installation, and scaling experienced, technically proficient teams capable of delivering within aggressive timelines." },
      { q: "How do you minimize service interruptions during network migrations and upgrades?", a: "We plan every cutover and migration in detail, including work sequencing, pre-validation of fibers, and close coordination with operations teams to ensure minimal disruption." },
      { q: "What is your pricing structure (hourly, project-based, retainer, etc.)?", a: "We offer flexible pricing models including project-based, unit-rate, time-and-materials, and programmatic agreements." },
      { q: "How do you handle scope changes?", a: "Scope changes are managed through a structured change-control process. We assess impact, clearly communicate cost and schedule implications, and proceed only with customer approval." },
      { q: "What documentation do you provide with your services?", a: "We deliver audit-ready documentation including as-built drawings, fiber routing details, splice records, labeling schedules, and test results such as OTDR and insertion loss. Documentation can also be structured for seamless integration with CMMS or network management systems." },
      { q: "How often do you provide status updates or performance reports?", a: "We provide regular updates tailored to each project, ranging from daily field reports for fast-track builds to weekly executive summaries for larger programs, ensuring stakeholders always have clear visibility into progress and next steps." },
      { q: "How do you escalate issues throughout a project?", a: "We follow a clear escalation path with defined decision-makers, response timelines, and accountability at every stage of the project." },
      { q: "Do you work around the clock?", a: "Yes. We support projects requiring nights, weekends, and maintenance-window work, with teams experienced in mission-critical environments where flexibility and rapid response are essential." },
      { q: "Are the staff assigned to my project dedicated or shared resources?", a: "For large or complex engagements, we provide dedicated teams led by experienced supervisors, while maintaining the flexibility to scale resources as project demands evolve." },
    ]

  },
];

const rows = [
  {
    need: "Are you short on skilled labor? Do you have a full deployment team?",
    feature: "Our team of project managers and engineers can scale up quickly to meet your schedule.",
    benefit: "Dial-up skilled fiber technical services when and where you need them.",
  },
  {
    need: "Are you wondering if your sub is  a value add?",
    feature: "We understand networking, engineering, and have the hands-on technical skills to install and turn-up networks. We document functional designs for ease of hand-off, managing day 2 updates, and trouble-shooting.",
    benefit: "Thorough processes, communication, and skilled staff keep your schedule and budget on track.",
  },
  {
    need: "Do you have blind spots in your network due to years of imperfect documentation? ",
    feature: "We offer network audits and assessments to map the fiber connectivity, network routing, and ensure you know what network elements are operational.",
    benefit: "Clear network documentation enables fast issue and outage resolution as well as a head-start on upgrade planning, saving time and money.",
  },
  {
    need: "Do you have a very aggressive deployment timeline, driven by SLAs, KPIs, or a hyper-competitive market?",
    feature: "Our team of project managers and engineers can scale up quickly to meet your schedule.",
    benefit: "Stay on track for investors. Monetize your network faster. Keep a competitive edge in the market.",
  },
  {
    need: "Do you have too many sub-contractors with too steep of a learning curve?",
    feature: "Our team of project managers and engineers, well-versed in network lifecycle and optical technologies, can scale up quickly to meet your schedule, working with your systems and teams to ensure a frictionless experience.",
    benefit: "Your schedule and budget stays on-track and team communication is clear.",
  },
  {
    need: "Are you tired of surprises throughout your projects throwing your schedule and budget off?",
    feature: "Our project managers and engineers focus on up-front planning, anticipating challenges from shipment scheduling to site readiness ensuring all project stars are aligned.",
    benefit: "Proper pre-deployment planning makes projects go faster and stay on-budget.",
  },
  {
    need: "Has your project become too complex, managing teams and technology, site readiness, multiple stakeholder expectations, and more?",
    feature: "Our professional services team assesses and manages every aspect of your project end-to-end, coordinating all communications and ensuring all dependencies and variables are planned and managed.",
    benefit: "Your schedule and budget stays on-track and team communication is clear.",
  }
];


function Services() {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  

    const [familyIndex, setFamilyIndex] = useState(0);
  const [familySlidesPerView, setFamilySlidesPerView] = useState(3);
  

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [open, setOpen] = useState(new Set());

useEffect(() => {
    const updateFamilySlidesPerView = () => {
      if (window.innerWidth <= 768) {
        setFamilySlidesPerView(1);
      } else if (window.innerWidth <= 1100) {
        setFamilySlidesPerView(2);
      } else {
        setFamilySlidesPerView(3);
      }
    };
  
    updateFamilySlidesPerView();
    window.addEventListener("resize", updateFamilySlidesPerView);
    return () => window.removeEventListener("resize", updateFamilySlidesPerView);
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    console.log('isMobile?', isMobile)
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggle = (key) => {
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };


  // ANCHOR LINKS
  useEffect(() => {
    // Check if the URL has an anchor (e.g., #planning)
    const hash = window.location.hash;
    
    if (hash) {
      // Get the ID (remove the '#')
      const id = hash.substring(1); 
      const element = document.getElementById(id);
      
      if (element) {
        // Use requestAnimationFrame to ensure the component is fully rendered 
        // before attempting to scroll, which is critical for dynamic content.
        requestAnimationFrame(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    } 
    // This effect runs whenever the Services page first loads or when the hash changes.
  }, [window.location.pathname, window.location.hash]);

    const [startIndex, setStartIndex] = useState(0);
  
    const next = () => {
      if (startIndex + 3 < topByFamily.length) {
        setStartIndex(startIndex + 1);
      }
    };
  
    const prev = () => {
      if (startIndex > 0) {
        setStartIndex(startIndex - 1);
      }
    };

const productFamilies = [
  'Fiber Cable Assemblies',
  'Fiber Panels',
  'Frames',
];

    const [counts, setCounts] = useState({
      years: 0,
      continents: 0,
      employees: 0,
    });

      useEffect(() => {
        const animationFrames = {};
        const durations = 600; // in ms
    
        facts.forEach(fact => {
          const start = performance.now();
    
          const animate = now => {
            const progress = Math.min((now - start) / durations, 1);
            const currentValue = Math.floor(progress * fact.value);
    
            setCounts(prev => ({
              ...prev,
              [fact.key]: currentValue,
            }));
    
            if (progress < 1) {
              animationFrames[fact.key] = requestAnimationFrame(animate);
            }
          };
    
          animationFrames[fact.key] = requestAnimationFrame(animate);
        });
    
        return () => {
          Object.values(animationFrames).forEach(cancelAnimationFrame);
        };
      }, []);

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')




useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);


  const topByFamily = productFamilies.map(famName => {
    const matchingProducts = filteredProducts.filter(
      p => (p.productFamily || '').trim() === famName
    );
    if (matchingProducts.length === 0) return null;

    const topProduct = matchingProducts.reduce((best, current) =>
      Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
    );

    return { family: famName, topProduct };
  }).filter(Boolean); // remove nulls if a family has no products


  const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);
  
  const nextFamily = () => {
    setFamilyIndex((prev) => Math.min(prev + 1, familyMaxIndex));
  };
  
  const prevFamily = () => {
    setFamilyIndex((prev) => Math.max(prev - 1, 0));
  };
  
  useEffect(() => {
    if (familyIndex > familyMaxIndex) {
      setFamilyIndex(familyMaxIndex);
    }
  }, [familyIndex, familyMaxIndex]);
  

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={'/support'} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>


<div className="solutions-section-1" style={{ marginTop: 30}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/services/ServicesImage.png" alt="Datacenter" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Keeping it simple has never been more important</h2>
          <p className="solution-section-1-description" style={{marginBottom: 40}}>Demands on data centers are rising, and Go!Foton meets the needs with turnkey, AI-ready network services. We deliver design, project management, installation, and integration efficiently with advanced fiber solutions. With proactive project support and risk management mindsets, we simplify and speed your growth path from concept to launch. Go!Foton makes it as straightforward as AI: simple, enabling, and transformative.​</p>
                 {/* <a
  href="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/brochures%2FGoFoton%20Mobile%20Vehicle%20Brochure.pdf?alt=media&token=450d9d41-a6e9-4fc7-bf03-73f6a584a045"
  className="cta-button"
  target="_blank"
  rel="noopener noreferrer"
>            DOWNLOAD THE BROCHURE
          </a>     */}
       
        </div>

      </div>


      <div style={{ backgroundColor: '#f9f9f9'}}>
      <div className="solutions-section-factoids">
        <h2 className="solutions-section-factoids-header">
          Quality cabling & installation services tie directly to network performance and customer satisfaction​
        </h2>

        <div className="solutions-section-factoid-grid">
          <div className="solutions-section-factoids-box-services" style={{ backgroundColor: '#8C277B' }}>
            <p className="solutions-section-factoid-text">The average cost of downtime for large enterprises was <span className="largerText">$23,750</span>/minute in 2024. For some Fortune 500 companies, the cost<span className="largerText"> &gt;$5M.</span>​</p>
            <p className="solutions-section-factoid-source">Source: <a href="https://www.bigpanda.io/">BigPanda, 2024</a></p>
          </div>

          <div className="solutions-section-factoids-box-services" style={{ backgroundColor: '#24BFBF' }}>
            <p className="solutions-section-factoid-text"><span className="largerText">1 in 3</span> enterprises reported 1+ cabling or installation-related network outages in the past year</p>
            <p className="solutions-section-factoid-source">Source: <a href="https://www.networkworld.com/">Network World, 2025</a></p>
          </div>

          <div className="solutions-section-factoids-box-services" style={{ backgroundColor: '#D94929' }}>
            <p className="solutions-section-factoid-text"><span className="largerText">72%</span> of execs said downtime directly impacted customer trust and retention​</p>
            <p className="solutions-section-factoid-source">Source: <a href="https://www.cockroachlabs.com/">Cockroach Labs, 2025</a></p>
          </div>

          <div className="solutions-section-factoids-box-services" style={{ backgroundColor: '#8FC54B' }}>
            <p className="solutions-section-factoid-text">Misconfigured routing & peering errors were among the ​<span className="largerText">top</span> non-power causes of downtime</p>
            <p className="solutions-section-factoid-source">Source: <a href="https://blog.cloudflare.com/">Cloudflare, 2025</a></p>
          </div>
        </div>
      </div>
      </div>


      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          
          <div className="solutions-section-checklist-image-wrapper">
            <img src="/images/services/image3.jpg" alt="Central Office" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <h2 className="solutions-section-checklist-heading">Relied-on for the fastest growing, most complex networks​</h2>
          <p className="solutions-section-checklist-description">Our professional services combine experienced fiber installation specialists with turnkey design, management, and operational support to ensure flawless execution, high capacity, and rapid scalability beyond day one.</p>
          <ul className="solutions-section-checklist-points">
            <li>Nationwide and global reach: over 2,000 technicians across the US and nearly 300 locations in Europe, Asia, the Middle East, and the Americas.​</li>
            <li>Scalable resourcing and service levels: dedicated teams available on 4, 8, or 24-hour response, high-scale mobilization, and vetted LVC design and installation.</li>
            <li>On-site expertise: Technical project managers and site operations superintendents are with installation crews at every site. They’re backed by in-house solution architects, technical supervisors, and project managers.​</li>
            <li>Efficient operations: formulaic, mass labeling, real-time tracking, and documentation.​</li>
          </ul>
        </div>
      </div>


      <div id="pre-deployment" className="solutions-section-alignRight-grey">
        <div className="solutions-section-alignRight-text-container">
          <h2 className="solutions-section-alignRight-subheading">Pre-deployment</h2>
          <p className="solution-section-alignRight-description">Before anything is shipped or installed, pre-deployment services are the critical readiness steps to ensure your project runs smoothly. Taking the time upfront to validate requirements, assess and ready the physical plant and hardware and software, ultimately saves time and money when surprise changes cost extra. Moreover, accurate planning minimizes waste by confirming precise needs and improves quality control. Some pre-deployment services include preparation of detailed RFQs, creation of BOMs based on customer designs, fiber mapping and testing, site surveys, engineering design services (such as fiber infrastructure planning and cable pathway design and determination of cable lengths), material procurement, inventory management, material staging, pre-configuring hardware and software, kitting and staging, testing and documentation, labeling, and logistics planning.</p>
        </div>

        <div className="solutions-section-alignRight-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FServices%20Pre%20Deployment.jpeg?alt=media&token=1e174958-6386-4bf0-a73d-1f9b0780bb88" alt="Datacenter" />
        </div>
      </div>


      <div id="project-management" className="solutions-section-1-grey">
        <div className="solutions-section-1-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fproject%20management%20laptop.png?alt=media&token=e9888e4d-1f60-4b4a-86c9-54d5cdd2c592" alt="Datacenter" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Project management</h2>
          <p className="solution-section-1-description">Project management is the epi-center of your project. These professionals coordinate the planning, organization, and execution of network projects managing scalable staffing needs when you are building new facilities, relocating infrastructure, or upgrading existing systems to ensure they are completed on time and within budget. Quality project managers guide strategic planning, facilitate site selection, coordinate the design, engineering, and construction teams. They coordinate multiple vendors and manage cost, schedules, risk, and oversee  test and turn-up prior to project handover. Simply put, they are the project eyes and ears that plan, communicate, escalate, and mitigate whatever needs to be done to ensure you're satisfied.</p>
          </div>
      </div>

      <div id="lvc" className="solutions-section-alignRight-grey">
        <div className="solutions-section-alignRight-text-container">
          <h2 className="solutions-section-alignRight-subheading">Low voltage cabling (LVC) services</h2>
          <p className="solution-section-alignRight-description">Low-voltage cabling (LVC) services for data centers encompass the design, installation, and maintenance of the high-speed, low-latency infrastructure required to support modern and AI-driven workloads – everything from a few megawatts to hundreds of megawatts. Staffed with our own highly trained site managers and supervisors, these professionals support structured cabling systems that provide an organized, scalable foundation; high-density solutions using MPO/MTP connectors to maximize fiber capacity; and both fiber-optic and copper DAC cabling to deliver fast, reliable connectivity across racks and backbones. Comprehensive cable management, labeling, along with rigorous testing and certification ensure operational efficiency and performance, while future-proofing strategies enable seamless growth as data demands and AI technologies evolve.</p>
        </div>

        <div className="solutions-section-alignRight-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FLVC%20Services.jpeg?alt=media&token=2da2a14b-9f64-43cb-9e35-ae3f3759f311" alt="Datacenter" />
        </div>
      </div>

      <div id="fiber-splicing" className="solutions-section-1-grey">
        <div className="solutions-section-1-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FFiber%20Splicing.png?alt=media&token=b6b17fa2-15d4-4511-ae07-7358db88d2df" alt="Datacenter" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Fiber splicing for ISP/OSP</h2>
          <p className="solution-section-1-description">Splicing services encompass the end-to-end installation, routing, termination, and testing of both outside plant (OSP) and inside plant (ISP) fiber infrastructure. For OSP, this often includes placing fiber in underground conduit or aerial pathways between buildings, managing handholes and manholes, installing building entrance facilities, and performing fusion splicing in closures or cabinets to interconnect backbone fibers and provide protected transitions into each facility. For ISP and data centers, we install backbone and riser fiber within conduits, sleeves, ladder trays, and vertical pathways, dress and securing cables to meet bend-radius, fire-stopping, and separation requirements, and terminate fibers in splice enclosures, patch panels, or fiber distribution frames. We offer precision fusion splicing of single-mode or multimode fibers, organization and labeling of fibers, and comprehensive testing (OTDR, insertion loss, and continuity) to verify performance and readiness for service.</p>
          </div>
      </div>

        <div id="post-deployment" className="solutions-section-alignRight-grey">
        <div className="solutions-section-alignRight-text-container">
          <h2 className="solutions-section-alignRight-subheading">Post deployment, day 2 services</h2>
          <p className="solution-section-alignRight-description">Networks are constantly evolving and adapting, just like AI itself. Our team keeps the focus on the ongoing maintenance, monitoring, optimization, and continuous adaptation of your specialized infrastructure to ensure sustained performance, reliability, and cost-effectiveness for demanding AI and machine learning (ML) workloads. Some of the services include testing, software and storage upgrades and optimization, capacity planning and scaling, data migration, hardware and software maintenance and lifecycle management.</p>
        </div>

        <div className="solutions-section-alignRight-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FServices%20Post%20Deployment.jpeg?alt=media&token=fcd56275-b63f-4783-b367-aabe19f2ffb3" alt="Datacenter" />
        </div>

      </div>


      <div className="solutions-section-1" style={{ backgroundColor: '#f8f8f8'}}>
<div className="solutions-section-alignRight-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FDistribution%20Frame.png?alt=media&token=be3214a4-e086-4914-ac5f-0f3d0b1f5a59" alt="Datacenter" />
        </div>
  <div
    className="solutions-section-1-text-container"
    style={{
      display: 'flex',
      flexDirection: 'column', // makes alignSelf work
      alignItems: 'flex-end',  // aligns all content to the right
      marginTop: 90,
      marginBottom: 50,
    }}
  >
    <h2 className="solutions-section-1-subheading">
      Turnkey services using connectivity that doesn’t compromise
    </h2>
    <p className="solution-section-1-description">
      Our fiber optic solutions are designed to accommodate maximum density without compromising serviceability. ​
    </p>
    <a
      className="cta-button"
      style={{ marginTop: 20, alignSelf: 'flex-start' }}
      href="/knowledge-center?doc=product-catalog-featured"
    >
      Our Catalog
    </a>
</div>


        
      </div>

      <div className="solutions-section-centeredText" style={{ backgroundColor: '#f8f8f8', position: 'relative'}}>
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Bundling services and connectivity pays</h2>
          <p className="solution-section-centeredText-description">When networks become more complex, your partnerships don’t have to. We help combat complications by providing streamlined, turnkey services that help save time, money, and headaches.</p>
        


       <div className="solutions-icon-grid-2">
            <div className="icon-item">
              <img src="/images/services/icons/megaphone.png" alt="Icon 1" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10}}>Streamlined communications​</p>
            </div>
            <div className="icon-item">
              <img src="/images/services/icons/bullseye.png" alt="Icon 2" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Single point of contact accountability</p>
            </div>
            <div className="icon-item">
              <img src="/images/services/icons/calendar.png" alt="Icon 3" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Aligned schedules</p>
            </div>
            <div className="icon-item">
              <img src="/images/services/icons/dollarSign.png" alt="Icon 4" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Simplified buying saves time & mark-ups</p>
            </div>
            <div className="icon-item">
              <img src="/images/services/icons/globe.png"alt="Icon 5" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Nationwide & global reach</p>
            </div>
            <div className="icon-item">
              <img src="/images/services/icons/stackedBlocks.png" alt="Icon 3" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Scalable resourcing & service levels</p>
            </div>
            <div className="icon-item">
              <img src="/images/services/icons/hardHat.png" alt="Icon 4" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>On-site expertise</p>
            </div>
            <div className="icon-item">
              <img src="/images/services/icons/efficient.png"alt="Icon 5" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Efficient operations</p>
            </div>
          </div>

          </div>

          <div className={'curved-divider-bottom'} />
      </div>


    <section className="solution-products-section" style={{ backgroundColor: 'white'}}>
      <h2>Turnkey solutions for fiber networks​</h2>
      {/* <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p> */}
<div className="article-slider-container">
  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-left ${familyIndex === 0 ? "disabled" : ""}`}
      onClick={prevFamily}
      disabled={familyIndex === 0}
    >
      &#10094;
    </button>
  )}

  <div className="article-slider-viewport">
    <div
      className="article-slider-track"
      style={{
        transform: `translateX(-${familyIndex * (100 / familySlidesPerView)}%)`,
        "--content-slides-per-view": familySlidesPerView,
      }}
    >
      {topByFamily.map((article, idx) => (
        <div className="article-slider-slide" key={idx}>
          <div className="image-slider-card">
            <div className="image-logo-wrapper">
              <img
                src={
                  article.topProduct
                    ? article.topProduct.image
                    : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAI%20Data%20Center%20Image%20(1).jpg?alt=media&token=367424a2-ef6c-4e88-a8dc-8ac186a99ac1"
                }
                alt="logo"
                className="image-logo"
              />
            </div>

            <h3>{article.family}</h3>

            <a
              className="cta-button"
              href={article.topProduct ? `/${article.slug}` : `/services`}
              style={{ textDecoration: "none" }}
            >
              View
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>

  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-right ${familyIndex === familyMaxIndex ? "disabled" : ""}`}
      onClick={nextFamily}
      disabled={familyIndex === familyMaxIndex}
    >
      &#10095;
    </button>
  )}
</div>
{/* <div className="article-slider-container">
      <button
        className="article-slider-arrow"
        onClick={prev}
        disabled={startIndex === 0}
      >
        ◀
      </button>

      <div className="article-slider-window">
        {topByFamily.slice(startIndex, startIndex + 3).map((article, idx) => (
          <div className="image-slider-card" key={idx}>
           <div className="image-logo-wrapper">
              <img src={article.topProduct ? article.topProduct.image : 'https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAI%20Data%20Center%20Image%20(1).jpg?alt=media&token=367424a2-ef6c-4e88-a8dc-8ac186a99ac1'} alt="logo" className="image-logo" />
            </div>
            <h3>{article.family}</h3>
            <a
              className="cta-button"
              href={article.topProduct ? `/${article.slug}` : `/services`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none'}}
            >
              View
            </a>
          </div>
        ))}
      </div>

      <button
        className="article-slider-arrow"
        onClick={next}
        disabled={startIndex + 3 >= topByFamily.length}
      >
        ▶
      </button>
    </div> */}


{/* <div className="solutions-section-centeredText" style={{ marginTop: 50 }}>
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">According to the Uptime Institute, the most common causes of data center issues are:</h2>
          <div className="factory-facts">
                {facts.map(fact => (
                  <div className="fact" key={fact.key}>
                    <div className="fact-number" style={{ color: "#85246D" }}>
                      {fact.prefix}{counts[fact.key]}{fact.suffix}
                    </div>
                    <div className="fact-label">{fact.label}</div>
                  </div>
                ))}
              </div>
        </div>
      </div> */}

<div style={{ paddingRight: '2vw', marginTop: 100, paddingLeft: '2vw', alignItems: 'flex-start'}}>
          <h2 style={{ textAlign: 'left'}} className="solutions-section-checklist-heading">Does any of this sound like you?</h2>
          <p style={{ marginTop: -30, marginBottom: 40}} className="solutions-section-checklist-description">Here’s a look at how Go!Foton ensures your projects to stay on time and on budget.</p>
         </div>

         <img
  src="/images/solutions/datacenterTable.png"
  alt="Datacenter Table"
  className="responsive-image-table"
/>


<div className="fb-table">
      <div className="fb-row fb-header">
        <div className="fb-cell fb-need-header">Does this sound like you?</div>
        <div className="fb-cell fb-feature-header">Our service</div>
        <div className="fb-cell fb-benefit-header">Your benefit</div>
      </div>

      {rows.map((r, i) => (
        <div className="fb-row" key={i}>
          <div className="fb-cell fb-need">{r.need}</div>
          <div className="fb-cell fb-feature">{r.feature}</div>
          <div className="fb-cell fb-benefit">{r.benefit}</div>
        </div>
      ))}
    </div>


    </section>

<section className="solution-products-section" style={{ backgroundColor: 'white'}}>
      <h2>Recent Blogs</h2>
      {/* <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p> */}

<div className="products-grid">
    <div className="product-card">
        <img
          src="/images/services/image4.jpg"
          style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
      
      <h3>The importance of fiber density in AI Datacenters</h3>
      <h5>Sep 13, 2024</h5>
      <p style={{marginBottom: 30}}>Fiber optics serve as the backbone of modern networks, connecting critical equipment and software. In AI data centers...</p>
      <a
        className="cta-button"
        style={{marginTop: 'auto', marginBottom: 20}}
        href='/the-importance-of-fiber-density-in-ai-data-centers'
      >
        Learn More
      </a>
    </div>
    <div className="product-card">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FEVA_16F-MMF_2x8_MPO-DXLCU_FA_with-cover.png?alt=media&token=1da6fccb-b00d-4ea1-a8c3-69984db328a3"
          style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
      
      <h3>Fiber optic basics in the age of AI datacenters</h3>
      <h5>Sep 12, 2024</h5>
      <p style={{marginBottom: 30}}>As data centers evolve to support new AI companies and AI-based applications, fiber optic connectivity has become...</p>
      <a
        className="cta-button"
        style={{marginTop: 'auto', marginBottom: 20}}
        href='/fiber-optic-basics-in-the-age-of-ai-datacenters'
      >
        Learn More
      </a>
    </div>
</div>
</section>

<section className="faq-wrap">
      {/* <h2 className="faq-title">Answers to Common Questions</h2> */}
      <center>
      <button
        className="accordion-header"
        style={{ width: '90%', marginBottom: 20}}
        //onClick={() => toggleSection('faq')}
      >
        Answers to Common Questions
        <span className="accordion-icon">
        </span>
      </button>
      </center>

      <div className="faq-grid">
        {data.map((section, sIdx) => (
          <div className="faq-col" key={sIdx}>
            <h3 className="faq-col-title">{section.title}</h3>

            <div className="faq-list">
              {section.items.map((item, iIdx) => {
                const key = `${sIdx}-${iIdx}`;
                const isOpen = open.has(key);
                return (
                  <div className={`faq-item ${isOpen ? "open" : ""}`} key={key}>
                    <button
                      className="faq-question"
                      onClick={() => toggle(key)}
                      aria-expanded={isOpen}
                    >
                      <span>{item.q}</span>
                      <span className="faq-icon">{isOpen ? "–" : "+"}</span>
                    </button>

                    <div
                      className="faq-answer"
                      style={{ maxHeight: isOpen ? "200px" : "0px" }}
                    >
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>


      {/* <div className="solutions-section-1" style={{ marginTop: 60}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/services/ServicesImage.png" alt="Datacenter" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Your AI Data Center Services Roadmap</h2>
          <p className="solution-section-1-description">AI demands are rising, and Go!Foton meets it with turnkey, AI-ready network services. We deliver design, project management, installation, and integration efficiently, using advanced fiber solutions. With proactive support and risk management, we simplify your path from concept to launch. Go!Foton makes it as straightforward as AI: simple, enabling, transformative</p>
          </div>
      </div>



      <div className="solutions-section-alignRight" style={{ marginBottom: -100}}>
          <p className="solution-section-alignLeft-description">Our professional services combine experienced fiber installation specialists with turnkey design, management, and operational support to ensure flawless execution, high capacity, and rapid scalability beyond day one. Here’s why so many industry leaders turn to us:</p>
        
        <ul style={{marginTop: -40}}>
          <li>Nationwide and global reach: over 2,000 technicians across the US and nearly 300 locations in Europe, Asia, the Middle East, and the Americas, leveraging local talent where possible.</li>
          <li>Scalable resourcing and service levels: dedicated teams available on 4, 8, or 24-hour response, high-scale mobilization, and vetted LVC design and installation contractors under Go!Foton NDA and MSA.</li>
          <li>On-site expertise: architect and engineer-level supervisors guiding installation crews at every site, backed by in-house solution architects, technical supervisors, and project managers.</li>
          <li>Efficient operations: formulaic, mass labeling and a singular live document for real-time tracking.</li>
        </ul><br/><br/>
        
        </div> */}



{/* 

Our professional services combine experienced fiber installation specialists with turnkey design, management, and operational support to ensure flawless execution, high capacity, and rapid scalability beyond day one.  Here’s why so many industry leaders turn to us.
•	Nationwide and global reach: over 2,000 technicians across the US and nearly 300 locations in Europe, Asia, the Middle East, and the Americas, leveraging local talent where possible.
•	Scalable resourcing and service levels: dedicated teams available on 4, 8, or 24-hour response, high-scale mobilization, and vetted LVC design and installation contractors under Go!Foton NDA and MSA.
•	On-site expertise: architect and engineer-level supervisors guiding installation crews at every site, backed by in-house solution architects, technical supervisors, and project managers.
•	Efficient operations: formulaic, mass labeling and a singular live document for real-time tracking.

*/}

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions" style={{ backgroundColor: 'white'}}></div>
        
        <h2>Unlock Your Turnkey AI Network Today</h2>
        <p>Contact us for a Project Review and Next Steps</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default Services;
